export default __webpack_public_path__ + "static/media/grab.99d6cea0.webp";